<template>
  <UgBalloon class="top-menu-help-balloon" :direction="BalloonDirection.TopEnd">
    <div v-for="(link, index) in links" :key="index" class="top-menu-help-balloon__item" @click="onClick(link.href)">
      <UgIcon :icon="link.icon" width="16px" height="16px" />
      <UgButton
        class="top-menu-help-balloon__button"
        data-test="account-settings-button"
        tertiary
        icon="link-square"
        :text="link.text"
        width="16"
        height="16"
        icon-right
      />
    </div>
  </UgBalloon>
</template>

<script setup lang="ts">
import { UgButton, UgBalloon, UgIcon, BalloonDirection } from "@bebit/atomic";
import { useI18n } from "vue-i18n";
import type { Icon } from "@bebit/atomic";

const { t } = useI18n();

interface Link {
  icon: Icon;
  text: string;
  href: string;
}

const links: Link[] = [
  {
    icon: "mortarboard",
    text: t("onlineSupport"),
    href: "https://blog.usergram.info/",
  },
  {
    icon: "help",
    text: t("helpSite"),
    href: "https://help.usergram.info/",
  },
];

const onClick = (url: string) => {
  window.open(url);
};
</script>

<style lang="scss" scoped>
.top-menu-help-balloon {
  box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
  list-style: none;
  width: 200px;

  ::before {
    border: 8px solid transparent;
    border-bottom-color: $colorGray600;
    right: 17px;
    top: -16px;
  }

  ::after {
    border: 8px solid transparent;
    border-bottom-color: $colorWhite;
    right: 17px;
    top: -15px;
  }
}

.top-menu-help-balloon__button {
  color: $colorGray800;
  justify-content: start;
  padding-left: 8px;
  &:first-child {
    margin-bottom: 4px;
  }
  :deep(.ug-button__icon) {
    height: 11px;
    width: 11px;
  }

  :deep(.ug-button__text) {
    margin-right: 10px;
  }
}

.top-menu-help-balloon__item {
  align-items: center;
  background-color: $colorWhite;
  color: $colorBase900;
  cursor: pointer;
  display: flex;
  height: 40px;
  padding-left: 22px;
  padding-right: 22px;

  :deep(.ug-button__text) {
    color: #323442;
    font-size: 14px;
    line-height: 1.3;
  }

  :deep(.ug-button__icon path) {
    fill: $colorBase700;
  }

  :deep(path) {
    fill: $colorBase700;
  }

  &:first-child {
    margin-top: 10px;
  }

  &:last-child {
    margin-bottom: 10px;
  }

  &:hover {
    background-color: $v1ColorBlue600;

    :deep(path) {
      fill: $colorBase900;
    }

    :deep(.top-menu-help-balloon__button path) {
      fill: $colorBase900;
    }
  }
}
</style>

<i18n lang="yaml">
en:
  helpSite: Help site
  onlineSupport: Blog
ja:
  helpSite: ヘルプサイト
  onlineSupport: 活用ブログ
zh-hant:
  helpSite: 幫助網站
  onlineSupport: Blog
zh-hans:
  helpSite: 帮助网站
  onlineSupport: Blog
</i18n>
